/**
 * Returns the API configuration with authentication headers
 * @returns {Object} API configuration object with headers
 */
export const getApiConfig = () => {
  // Your backend uses HttpOnly cookies for authentication
  // No need to extract token from localStorage
  return {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true // This is important for sending cookies with the request
  };
};
